module.exports = __webpack_public_path__ + "img/2_Archive_2.47ecd41d.jpg";